// ---------------------------------------------------------------------------
// Renderer: Section Header
//
// Chrome label that sits above a column/band.  Font scale is pegged to the
// slide's original scale (chromeFontScale) so section headers never shrink
// when sibling content overflows.
// ---------------------------------------------------------------------------

import Konva from "konva";
import CustomText from "../CustomText";
import { themeColor, defaultTheme } from "../renderers/plainObjectRenderer";

export function renderSectionHeader(block, crystalizedData, options) {
  const { x = 0, y = 0, width = 300, imageCallback, theme, fontScale = 1 } = options;
  const s = options.chromeFontScale ?? fontScale;
  const themeColors = theme || defaultTheme;
  const group = new Konva.Group({ x, y, width });

  const text = (block.text || block.label || "").toUpperCase();
  if (!text) return group;

  const padTop = Math.round(2 * s);
  const padBottom = Math.round(10 * s);
  const labelNode = new CustomText({
    x: 0, y: padTop, width,
    text, fontSize: Math.round(11 * s), fontStyle: "bold",
    letterSpacing: Math.round(1.5 * s),
    fill: themeColor(themeColors, "textSecondary", "#888"),
    lineHeight: 1.2, refreshCallback: imageCallback
  });
  group.add(labelNode);
  // Tag for container-level click resolution
  if (block.id) {
    labelNode.setAttr("_evidenceProvKey", block.id);
    labelNode.setAttr("_blockId", block.id);
  }
  group.height(labelNode.height() + padTop + padBottom);
  return group;
}
